export default __webpack_public_path__ + "static/media/Arcor.dda748a3.png";